import { JwtPayload } from "@/types/User";
import { makeObservable, observable } from "mobx";

class User {
    user_info: JwtPayload | null = null;
    uploadedImage: File | null = null;
    constructor() {
        makeObservable(this, {
            user_info: observable,
            uploadedImage: observable
        })
    }
}

const user = new User();
export default user;